var _rect, _rect2, _ellipse, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhase1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 120,
    viewBox: "0 0 207 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119.25,
    height: 119.25,
    rx: 11,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 0.109375 59.6218)",
    fill: "url(#paint0_linear_541_16653)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 87.108,
    height: 87.108,
    rx: 14,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 27.8828 58.7769)",
    fill: "url(#paint1_linear_541_16653)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.001,
    cy: 58.2437,
    rx: 13,
    ry: 5,
    fill: "#7E613A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.05 43.6868C111.05 51.7583 103.743 58.3014 103.743 58.3014C103.743 58.3014 96.4355 51.7583 96.4355 43.6868C96.4355 35.6154 103.743 29.0723 103.743 29.0723C103.743 29.0723 111.05 35.6154 111.05 43.6868Z",
    fill: "#3CD035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.121 48.314C104.96 52.4838 103.336 58.5373 103.336 58.5373C103.336 58.5373 97.1082 57.8304 94.2689 53.6606C91.4296 49.4909 93.0539 43.4373 93.0539 43.4373C93.0539 43.4373 99.2816 44.1443 102.121 48.314Z",
    fill: "#388134"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_541_16653",
    x1: 45.1329,
    y1: -14.4922,
    x2: 83.8873,
    y2: 174.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133966,
    stopColor: "#95764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E653C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_541_16653",
    x1: 32.968,
    y1: -10.586,
    x2: 61.2767,
    y2: 127.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133966,
    stopColor: "#95764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E653C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase1);
export default __webpack_public_path__ + "static/media/phase1.b5b1f0a417d31d5c10916c53767bfe14.svg";
export { ForwardRef as ReactComponent };